import { getClientStore } from '../state';
import { IAuthData } from '../types';
import { isTalkie } from '../utils/env';
import { uaInfo } from '../utils/system';
// common params
export const OS_TYPE = 3;
export const APP_ID = isTalkie ? 300 : 600;
export const VERSION_CODE = 2120000;
export const VERSION_NAME = '2.12.000';

export const getCommonParams = (authData?: IAuthData) => {
  const commonParams = {
    user_id: 0,
    device_id: 0,
    os: OS_TYPE,
    app_id: APP_ID,
    // P0 fix: lazy eval 避免 module init 顺序 TDZ (Rollup lazy chunk 把 system.ts 排在 params.ts 后会触发 'Cannot access uaInfo before initialization')
    device_platform: uaInfo.isH5 ? 'mobile' : 'pc',
    version_code: VERSION_CODE,
    version_name: VERSION_NAME,
  };
  if (typeof window !== 'undefined') {
    const localAuthData = getClientStore().getState().user.authData;
    commonParams.user_id = Number(localAuthData?.userId || 0);
    commonParams.device_id = Number(localAuthData?.deviceId || 0);
  } else {
    // server 获得参数里的 authData
    commonParams.user_id = authData?.userId || 0;
    commonParams.device_id = authData?.deviceId || 0;
  }

  return commonParams;
};

export const wrapQueryParams = (params: Record<string, string | number>) => {
  const commonParams = getCommonParams();

  return {
    ...commonParams,
    ...params,
  };
};
